import { CheckCircle2 } from "lucide-react";
import { StaggerChildren, StaggerItem } from "@/components/Motion";

const BADGES = [
  { title: "Fully TIG-Welded Frame", sub: "Not bolt-together" },
  { title: "300kg Dynamic Roof Load", sub: null },
  { title: "10-Year Manufacturer Frame Guarantee", sub: null },
];

// v2 — no card/box/border/blur, just bare text + a large premium green
// checkmark sitting directly on the hero photo, kept legible via heavy
// text-shadow instead of a background surface. Desktop: absolute lower-right
// of the hero. Mobile: normal document flow beneath the existing hero
// content (never overlapping the CTAs). Test treatment — currently wired to
// render only on the Hilux 2026 Onwards page pending approval.
export const HeroTrustBadgesV2 = () => (
  <StaggerChildren
    className="relative mt-8 flex flex-col gap-6 w-full z-20 md:absolute md:mt-0 md:bottom-12 md:right-12 md:w-auto md:items-start"
    aria-label="Trust Badges"
  >
    <ul data-testid="hero-trust-badge-stack" className="flex flex-col gap-6">
      {BADGES.map((b, i) => (
        <StaggerItem key={i}>
          <li
            data-testid="hero-trust-badge-item"
            className="flex items-start md:items-center gap-4 md:gap-5 transition-transform duration-300 hover:-translate-y-1"
          >
            <CheckCircle2
              className="w-9 h-9 md:w-10 md:h-10 text-emerald-500 shrink-0 drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]"
              strokeWidth={2}
              fill="currentColor"
              fillOpacity={0.15}
              aria-hidden="true"
            />
            <span className="flex flex-col text-left">
              <span className="font-display text-lg md:text-xl font-bold tracking-tight text-white [text-shadow:_0_2px_20px_rgba(0,0,0,0.9)]">
                {b.title}
              </span>
              {b.sub && (
                <span className="font-mono text-xs md:text-sm uppercase tracking-[0.15em] text-white/80 mt-1 [text-shadow:_0_2px_15px_rgba(0,0,0,0.9)]">
                  {b.sub}
                </span>
              )}
            </span>
          </li>
        </StaggerItem>
      ))}
    </ul>
  </StaggerChildren>
);
